import { PARegistry } from "../singletons/pa-registry";
import * as mapboxgl from "mapbox-gl";
import { PACoordinates } from "./coordinates";
import { FireUpdateOnChange } from "./util-classes/fire-update-on-change";
import type { PATechnicianDate } from "./technician-date";

export class DraggableDestinationMarker extends FireUpdateOnChange<'coordinates_changed'>{

  executeBeforeChange(): void {
  }

  public marker: mapboxgl.Marker
  private _coordinates: PACoordinates

  constructor(
    private _map: mapboxgl.Map,
    private _technicianDate: PATechnicianDate,
    //private _travelTechnicianDate: TravelTechnicianDate,
    readonly color: string,
    startCoordinates?: PACoordinates
  ) {
    super()
    this.marker = this.generateDestinationMarker()
    if (startCoordinates) {
      this.marker.setLngLat([startCoordinates.longitude, startCoordinates.latitude])
      this._coordinates = new PACoordinates(startCoordinates.latitude, startCoordinates.longitude, startCoordinates.name)
      /*this.updateCircle()*/
    }
    if (this._map) this.marker.addTo(this._map)
    this.marker.on('dragend', () => {
      const lnglat = this.marker.getLngLat()
      if (this._map) {
        const possible_tdc = PARegistry.tourPlannerControl.tourPlannerOverviewTechnicianDateCollections.find(tdc => tdc.mapContainer.map == this._map)
        if (possible_tdc?.autoOptimizeTravelDestinationsForDayTimestamps.includes(this._technicianDate.day.utc_timestamp)) {
          possible_tdc.toggleAutomaticTravelDestinationOptimizationForTimestamp(this._technicianDate.day.utc_timestamp)
        }
      }
      this.coordinates = new PACoordinates(lnglat.lat, lnglat.lng);
    })
    /*this.initDistanceSubscription()*/
  }

  /*initDistanceSubscription() {
    PARegistry.tourPlannerControl.distanceChangeSubject.subscribe(_ => {
      this.updateCircle()
    })
  }*/

  get map() {
    return this._map
  }

  set map(map: mapboxgl.Map) {
    if (this._map != map) {
      if (this._map) {
        this.marker.remove()
        //this.removeCircle()
      }
      if (map) {
        this.marker.addTo(map)
      }
      this._map = map
      /*this.updateCircle()*/
    }
  }

  get coordinates() {
    return this._coordinates
  }

  set coordinates(coords: PACoordinates) {
    if (this.coordinates.latitude != coords.latitude || this.coordinates.longitude != coords.longitude) {
      this._coordinates = coords
      if (coords) {
        this.marker.setLngLat([coords.longitude, coords.latitude])
        this.fireUpdate('coordinates_changed')
      }
      /*this.updateCircle()*/
      /*this._travelTechnicianDate.updateLocation()
      this.updateTravelTechnicianDateTours()*/
    }
  }

  /*updateTravelTechnicianDateTours(): void {
    this._travelTechnicianDate.hasChanged()
  }*/

  /*updateCircle(radius?: number): void {
    radius = radius || PARegistry.tourPlannerControl.selectedDistanceFilter
    if (this.map) {
      let last_id = this._currentCircleId

      this._currentCircleId = this.coordinates ? `destination_circle_${this._travelTechnicianDate.technicianID}_${this._travelTechnicianDate.timestamp}_${this.coordinates.longitude},${this.coordinates.latitude}_${radius}` : ''

      if (last_id != this._currentCircleId) {
        if (last_id) {
          this.map.removeLayer(last_id)
          this.map.removeSource(last_id)
        }
        if (this._currentCircleId) {
          let circle = PAUtil.createGeoJSONCircle([this.coordinates.longitude, this.coordinates.latitude], radius)
          if (!this.map.getSource(this._currentCircleId)) {
            this.map.addSource(this._currentCircleId, circle);
          }

          if (!this.map.getLayer(this._currentCircleId)) {
            this.map.addLayer({
              "id": this._currentCircleId,
              "type": "fill",
              "source": this._currentCircleId,
              "layout": {},
              "paint": {
                "fill-color": "blue",
                "fill-opacity": 0.2
              }
            });
          }
        }
      }
    }
  }*/

  generateDestinationMarker(): mapboxgl.Marker {
    const el = document.createElement('div')
    el.style.backgroundSize = '100%'
    el.style.cursor = 'pointer'
    el.style.width = '28px'
    el.style.height = '28px'
    el.classList.add('destination_background_container')

    const el_svg_border = document.createElement('div')
    el_svg_border.classList.add('destination_background_border')

    const el_svg = document.createElement('div')
    el_svg.classList.add('destination_background')
    el_svg.style.backgroundColor = this.color

    el.appendChild(el_svg)
    el.appendChild(el_svg_border)
    return new mapboxgl.Marker(el, {draggable: true})
  }

/*  removeCircle(): void {
    if (this._currentCircleId && this.map) {
      this.map.removeLayer(this._currentCircleId)
      this.map.removeSource(this._currentCircleId)
      this._currentCircleId = ''
    }
  }*/

  remove(): void {
    this.marker.remove()
  }

}
